<template>
    <div class="fill-height">
        <TabBasic ref="tabBasic" :items="tabs" show-breadcrumbs>
            <template v-slot:header>
                <v-spacer/>
                <div v-if="showNotificationsBack" class="pointer" @click="navigateBack">
                    <v-icon color="accentText">mdi-keyboard-backspace</v-icon>
                </div>
            </template>
        </TabBasic>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";

export default {
  name: "NotificationBasic",
  components: {TabBasic},
  mounted() {
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
  data() {
    return {
      tab: null,
      openAddEditDialog: false,
      sendContextParams: {},
    };
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        if (to.name !== 'sendNotifications') {
          return;
        }
        const p = to.params || {};
        const zoneID = p.zoneID != null && p.zoneID !== '' ? p.zoneID : null;
        const circleID = p.circleID != null && p.circleID !== '' ? p.circleID : null;
        if (zoneID || circleID) {
          this.sendContextParams = {
            ...(zoneID ? {zoneID} : {}),
            ...(circleID ? {circleID} : {}),
          };
        } else {
          this.sendContextParams = {};
        }
      },
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    tabs() {
      if (!this.isAdmin) {
        return [];
      }

      return [
        {
          title: this.$t('menu.notifications'),
          to: {
            name: 'sendNotifications',
            params: this.preservedSendNotificationParams,
          }
        },
        {
          title: this.$t('notifications.history'),
          to: {
            name: 'notificationHistory'
          }
        }
      ]
    },
    preservedSendNotificationParams() {
      if (this.$route.name === 'sendNotifications') {
        const p = this.$route.params || {};
        const fromRoute = {};
        if (p.zoneID != null && p.zoneID !== '') {
          fromRoute.zoneID = p.zoneID;
        }
        if (p.circleID != null && p.circleID !== '') {
          fromRoute.circleID = p.circleID;
        }
        if (Object.keys(fromRoute).length) {
          return fromRoute;
        }
      }
      return {...this.sendContextParams};
    },
    showNotificationsBack() {
      if (this.$route.name !== 'sendNotifications') {
        return false;
      }
      const p = this.$route.params;
      return !!(p.zoneID || p.circleID);
    }
  },
  methods: {
    navigateBack() {
      this.$router.back();
    },
    handleKeyup(e) {
      if (e.key === 'Escape') {
        this.$router.back();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "notification-basic";
</style>